var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:['lazy-image', _vm.isLoaded && 'loaded'],attrs:{"loading":_vm.eager ? 'eager' : 'lazy',"src":_vm.source,"srcset":_vm.sourceSet},on:{"load":_vm.processLoadedImage}})}
var staticRenderFns = []

export { render, staticRenderFns }